import { Duration, Effect, Option } from 'effect';

import { TOKEN_EXPIRATION_WINDOW_SECONDS } from '@vs-shop/engine/config/tokenRefresh';

import { DEFAULT_TIMEZONE } from '../../../config/clock';

import { checkTokenStatus, TokenStatus } from '@vs-shop/engine/auth/jwt';

import { AuthToken } from '../../service/auth/AuthToken';

export const shouldRefreshToken = Effect.gen(function* () {
  const authTokenService = yield* AuthToken;

  const tokenOption = yield* authTokenService.getToken.pipe(
    Effect.orElseSucceed(() => Option.none<string>())
  );

  const expirationOption = yield* authTokenService.getRefreshTokenExpiration.pipe(
    Effect.orElseSucceed(() => Option.none<number>())
  );

  const status = yield* checkTokenStatus(
    tokenOption,
    Duration.seconds(TOKEN_EXPIRATION_WINDOW_SECONDS),
    DEFAULT_TIMEZONE,
    expirationOption
  );

  return status === TokenStatus.isCloseToExpiration || status === TokenStatus.isTokenExpired;
});
